
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './layout/Layout';

import {
  PageHome,
  SingleDevotion,
  SingleDay,
  PageCultureAndCustoms,
  PageLearnTheFaith,
  PagePrayerAndRites,
  SingleLearnTheFaith,
  SingleCatechesis,
  SinglePrayerAndRites,
  PageCalendar,
  PageSacredArt,
  PageFavorites,
  Account,
  TrinityAudioPlayer,
  LoginRegistration,
  Meditation

} from './pages';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../src/styles/custom-toasts.css';

import AudioPlayer from './components/AudioPlayer';
import { useAudioPlayer } from './context/AudioPlayerContext';
import { useEffect } from 'react';
function AppRoutes() {
  const location = useLocation()
  const { audioData, isPlaying, setIsPlaying, closeAudio } = useAudioPlayer();

  useEffect(() => {
    closeAudio();
  }, [location.pathname])

  return (
    <>
    
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<PageHome />} />
            <Route path="/calendar" element={<PageCalendar />} />
            <Route path="/meditation/:id" element={<Meditation />} />
            <Route path="/devotion/:slug" element={<SingleDevotion />} />
            <Route path='/single-day' element={<SingleDay />} />
            <Route path='/culture-and-customs' element={<PageCultureAndCustoms />} />
            <Route path='/culture-and-customs/:slug' element={<PageSacredArt />} />
            <Route path='/learn-the-faith' element={<PageLearnTheFaith />} />
            <Route path='/learn-the-faith/:slug' element={<SingleLearnTheFaith />} />
            <Route path='/learn-the-faith/catechesis/:id' element={<SingleCatechesis />} />
            <Route path='/prayer-and-rites' element={<PagePrayerAndRites />} />
            <Route path='/prayer-and-rites/:slug' element={<SinglePrayerAndRites />} />
            <Route path='/favorites' element={<PageFavorites />} />
            <Route path='/my-account' element={<Account />} />
          </Route>
          <Route path='/login' element={<LoginRegistration />} />
          <Route path='/audio-player' element={<TrinityAudioPlayer />} />
        </Routes>
      

      {audioData && (
        <AudioPlayer
          src={audioData.src}
          title={audioData.title}
          excerpt={audioData.excerpt}
          isPlaying={isPlaying}
          setIsPlaying={setIsPlaying}
          onClose={closeAudio}
          onProgressUpdate={() => { }}
        />
      )}
    </>

  );
}

function App() {
  return (

    <Router>
      <AppRoutes />
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </Router>
  )
}

export default App;
